@if (hasSearchResults) {
  <app-context-menu-item
    [withCheckOption]="true"
    [close]="true"
    title="All Results"
    [active]="!foldersOpen && !listStore.folder() && listStore.view() === 'search_results'"
    (execute)="select('search_results')"
  />
}
@for (view of views; track view.id) {
  <app-context-menu-item
    [withCheckOption]="true"
    [close]="true"
    [title]="view.title"
    [active]="!foldersOpen && !listStore.folder() && listStore.view() === view.id"
    (execute)="select(view.id)"
  />
}

<app-context-menu-item title="Folders" [withCheckOption]="true" [active]="foldersOpen || !!listStore.folder()" [close]="true" (execute)="select('folders')" />
